import Board from './components/Board'
import Tag from './components/Tag'
import Lane from './components/Lane'
import Card from './components/Card'

export {Board, Tag, Lane, Card}
export default Board
